"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyAttack = void 0;
const __1 = require("../..");
const EffectType_1 = require("../effects/EffectType");
const enums_1 = require("../enums");
const Calculators_1 = require("../state/Calculators");
const Random_1 = require("../../utils/Random");
const TimeInterval_1 = require("../vfx/TimeInterval");
const core_1 = require("../events/core");
const core_2 = require("../vfx/core");
function applyAttack(args) {
    // 1. duplicate attack vfx logic in applyAttackWithDamage method
    // 2.a. pass sequences down
    // 2.b. pass sequences up
    // 2.c. pass sequences up and down
    var _a, _b, _c, _d;
    // sequence
    // [move to]
    //   () => [swing weapon, [delay, show damage]]
    // [move back]
    // sequence
    // [projectile]
    //   [show damage, show damage, show damage]...
    const { abilityKey, attackerId, targetId, type } = args;
    let { sequence } = args;
    sequence = sequence.pushSequence("sequential");
    const { moveToVfx, returnToVfx } = __1.MoveCharacterVfxStepArgs.MoveAndReturn(attackerId, new __1.ActorVfxLocationSelector(targetId).movingForAbility(abilityKey));
    switch (type) {
        case "melee_aoe":
            sequence.push(moveToVfx);
            break;
        case "melee":
            sequence.push(moveToVfx);
            break;
    }
    const [critChance] = this.getAttributeScores(attackerId, [
        enums_1.AttributeType.CriticalStrikeChance
    ]);
    const attack = (0, Calculators_1.calculateAttackHit)(critChance);
    if (attack.hit && this.hasEffectOfType(attackerId, EffectType_1.EffectType.Darkness)) {
        const darknessStacks = this.getEffectsOfType(attackerId, EffectType_1.EffectType.Darkness)
            .reduce((sum, next) => { var _a; return sum + ((_a = this.getEffect(next).args.stacks) !== null && _a !== void 0 ? _a : 0); }, 0);
        attack.hit = (0, Random_1.randomPercent)() <= (100 - Math.min(30, darknessStacks * 5));
    }
    else if (attack.hit && this.hasEffectOfType(attackerId, EffectType_1.EffectType.Confused)) {
        attack.hit = (0, Random_1.randomPercent)() <= 70;
    }
    else if (attack.hit && this.hasEffectOfType(attackerId, EffectType_1.EffectType.Dizzy)) {
        attack.hit = (0, Random_1.randomPercent)() <= 70;
    }
    const unblockable = this.hasEffectOfType(attackerId, EffectType_1.EffectType.Unblockable);
    if (!unblockable && attack.hit && this.hasEffectOfType(targetId, EffectType_1.EffectType.Block)) {
        attack.hit = false;
        const [block] = this.getEffectsOfType(targetId, EffectType_1.EffectType.Block);
        this.cancelEffect(sequence, block);
    }
    if (unblockable) {
        attack.hit = true;
    }
    let innerSequence = sequence.pushSequence("parallel")
        .push(__1.BattleLogEntryVfxStepArgs.fromAttack(this, attackerId, targetId, attack));
    switch (type) {
        case "ranged_tick": {
            break;
        }
        case "magic_tick": {
            break;
        }
        case "melee_tick": {
            break;
        }
        case "melee": {
            innerSequence
                .push(new __1.AnimateCharacterAbilityVfxStepArgs(attackerId, abilityKey, "attacking", 1, args.idleAfter))
                // don't add a character sfx to avoid that and the ability playing at once. client should use the from arg provided here
                .push(new core_2.AbilitySoundEffectVfxStepArgs(attackerId, abilityKey, "start", "attacking"));
            innerSequence = innerSequence.pushSequence("sequential")
                .push(new __1.DelayVfxStepArgs(new TimeInterval_1.AbilityAnimationVfxTimeInterval(attackerId, args.abilityKey, "attacking")))
                // push a parallel sequence for everything that happens
                .pushSequence("parallel");
            break;
        }
        case "magic": {
            innerSequence
                .push(new __1.AnimateCharacterAbilityVfxStepArgs(attackerId, abilityKey, "casting", 1, args.idleAfter))
                // don't add a character sfx to avoid that and the ability playing at once. client should use the from arg provided here
                .push(new core_2.AbilitySoundEffectVfxStepArgs(attackerId, abilityKey, "start", "casting"));
            innerSequence = innerSequence.pushSequence("sequential")
                .push(new __1.DelayVfxStepArgs(new TimeInterval_1.AbilityAnimationVfxTimeInterval(attackerId, args.abilityKey, "casting")))
                // push a parallel sequence for everything that happens
                .pushSequence("parallel");
            break;
        }
        default: {
            innerSequence
                .push(new __1.AnimateCharacterAbilityVfxStepArgs(attackerId, abilityKey, "attacking", 1, args.idleAfter))
                // don't add a character sfx to avoid that and the ability playing at once. client should use the from arg provided here
                .push(new core_2.AbilitySoundEffectVfxStepArgs(attackerId, abilityKey, "start", "attacking"));
            innerSequence = innerSequence.pushSequence("sequential")
                .push(new __1.DelayVfxStepArgs(new TimeInterval_1.AbilityAnimationVfxTimeInterval(attackerId, args.abilityKey, "attacking")))
                // push a parallel sequence for everything that happens
                .pushSequence("parallel");
            break;
        }
    }
    this.getActor(targetId).lastAttackedBy = attackerId;
    this.emitEvent(innerSequence, attackerId, new __1.AttackEventArgs(targetId, attack.roll, attack.hit, attack.crit));
    this.emitEvent(innerSequence, targetId, new core_1.AttackedEventArgs(attackerId, attack.roll, attack.hit, attack.crit));
    (_a = args.onBeforeDamage) === null || _a === void 0 ? void 0 : _a.call(args, innerSequence, args);
    if (attack.hit) {
        innerSequence.push(new core_2.CharacterSoundEffectVfxStepArgs(targetId, "damaged")); // todo: move to damage effect
        if (!this.isDeceased(attackerId)) {
            innerSequence.push(new core_2.AbilitySoundEffectVfxStepArgs(attackerId, abilityKey, "hit"));
        }
        (_b = args.onHit) === null || _b === void 0 ? void 0 : _b.call(args, innerSequence, args, attack);
    }
    else {
        innerSequence
            .push(new __1.FloatingTextVfxStepArgs("Miss", new __1.ActorVfxLocationSelector(args.targetId, "head")))
            .push(new core_2.CharacterSoundEffectVfxStepArgs(targetId, "blocked"));
        if (!this.isDeceased(attackerId)) {
            innerSequence.push(new core_2.AbilitySoundEffectVfxStepArgs(attackerId, abilityKey, "miss"));
        }
        (_c = args.onMiss) === null || _c === void 0 ? void 0 : _c.call(args, innerSequence, args, attack);
    }
    (_d = args.onHitOrMiss) === null || _d === void 0 ? void 0 : _d.call(args, innerSequence, args, attack);
    switch (type) {
        case "melee_aoe":
            sequence.push(returnToVfx);
            break;
        case "melee":
            sequence.push(returnToVfx);
            break;
    }
    return {
        attack
    };
}
exports.applyAttack = applyAttack;
